// extracted by mini-css-extract-plugin
module.exports = {"meetWidgetContainer":"widget-space--meetWidgetContainer--1fog_","noWebRtc":"widget-space--noWebRtc--2c9So","noWebRtcMessage":"widget-space--noWebRtcMessage--3NsQE"};